import type { Client2TrackedTranslation } from '@ps/web-core-intl';
import { useTrackers } from '@ps/web-shared-analytics';
import type { MouseEvent, MouseEventHandler } from 'react';
import type React from 'react';

import Translation from '../../Translation/Translation';
import { useTrackingLabel } from '../../hooks';
import type { Props as RawProps } from '../RawButton/RawButton';
import RawButton from '../RawButton/RawButton';

type SVGProps = React.SVGAttributes<SVGElement>;

export interface Props extends Omit<RawProps, 'children' | 'icon'> {
  translation?: Client2TrackedTranslation;
  icon?: React.ReactElement<SVGProps, React.FunctionComponent<SVGProps> & { displayName: string }>;
  iconPosition?: 'before' | 'after';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values?: any;
  children?: undefined;
  routeValues?: { [key: string]: string };
  trackingValue?: number;
  onClick?(e: MouseEvent): void;
  trackingDimensions?: Record<string, string | number> | undefined;
}

const StarsButton: React.FC<Props> = ({
  icon,
  translation,
  iconPosition = 'before',
  onClick,
  values,
  routeValues = {},
  trackingValue,
  trackingDimensions,
  track = true,
  ...rest
}) => {
  const buttonName = useTrackingLabel(translation, values);
  const iconButton = !translation && !!icon;
  const { buttonPressed } = useTrackers();

  const handleClick: MouseEventHandler = (event) => {
    const name = iconButton && icon ? icon.type.displayName : buttonName;
    onClick && onClick(event);
    track && buttonPressed({ buttonName: name, value: trackingValue }, trackingDimensions);
  };

  return (
    <RawButton
      {...rest}
      track={false}
      icon={iconButton}
      onClick={handleClick}
      routeValues={routeValues}
    >
      {iconPosition === 'before' && icon}
      {translation && <Translation {...translation} values={values} />}
      {iconPosition === 'after' && icon}
    </RawButton>
  );
};

export default StarsButton;
